export { Button, buttonCss } from "./Button";
export type { ButtonProps, ButtonSize, ButtonVariant } from "./Button";
export { StampGrid, stampGridCss } from "./StampGrid";

import { buttonCss } from "./Button";
import { diagnosticsCss } from "./Diagnostics";
import { merchantSignInCss } from "./MerchantSignIn";
import { stampGridCss } from "./StampGrid";

/** Every component's styles, for the app to inject once at its root. */
export const componentCss = [buttonCss, stampGridCss, diagnosticsCss, merchantSignInCss].join("\n");
export { MerchantSignIn, merchantSignInCss } from "./MerchantSignIn";
export type { MerchantSignInWords } from "./MerchantSignIn";
export { MerchantSetup, takeSetupToken } from "./MerchantSetup";
export type { MerchantSetupWords } from "./MerchantSetup";
export { Mark, Wordmark } from "./Mark";

export { registerConsumerCss } from "./register-consumer";
export { registerMerchantCss } from "./register-merchant";
export { Diagnostics, diagnosticsCss } from "./Diagnostics";
export { ICON_NAMES, iconSvg } from "./icons";
